// extracted by mini-css-extract-plugin
export var cardLayout = "_6u-1";
export var paginationContainer = "_6u-0";